import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function useScreen() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));   // phones
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));   // >=600
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));   // >=900
  return { isXs, isSmUp, isMdUp };
}